import { useFeatureFlags } from './use-feature-flags';

export function useFeatureFlag(name) {
  return useFeatureFlags().includes(name);
}
